import React, { useState } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { motion } from 'framer-motion';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faUser, faIdCard, faPhone, faUserPlus } from '@fortawesome/free-solid-svg-icons';

/**
 * Register - Premium Registration form for new DataManager Admins
 */
const Register = ({ ipserv, onToggle, onSuccess, onForgot }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Nombre: '',
        Apellido: '',
        Cuit: '',
        Email: '',
        Telefono: '',
        Password: ''
    });
    const [emailError, setEmailError] = useState(false);

    const handleRegister = (e) => {
        e.preventDefault();
        setLoading(true);

        const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'auth/register', formData, r => {
            if (r.success) {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                } else {
                    Notify({ type: 'success', text: '¡Registro exitoso! Por favor, revisa tu correo electrónico.' });
                    onToggle(); 
                }
            } else {
                if (r.code === 'EMAIL_ALREADY_EXISTS') {
                    setEmailError(true);
                    Notify({ type: 'fail', text: 'El email ya está en uso.' });
                } else {
                    Notify({ type: 'fail', text: r.message || 'Error al registrarse' });
                }
            }
            setLoading(false);
        }, 'json', err => {
            console.error("Error detallado:", err);
            Notify({ type: 'fail', text: err.msg || 'Error de conexión' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <h1 className="auth-title">Crea tu cuenta</h1>
            <p className="auth-subtitle">Únete a DataManager y profesionaliza la gestión de tus datos.</p>

            {emailError && (
                <motion.div 
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    className="p-3 bg-danger-glass border-radius-12 mb-4 d-flex align-items-center justify-content-between"
                    style={{ border: '1px solid rgba(239, 68, 68, 0.2)', background: 'rgba(239, 68, 68, 0.1)' }}
                >
                    <div className="text-white small">
                        <strong className="d-block">Email en uso</strong>
                        Este correo ya tiene una cuenta asociada.
                    </div>
                    <button 
                        type="button" 
                        className="btn btn-sm btn-light font-weight-bold" 
                        onClick={onForgot}
                        style={{ borderRadius: '8px' }}
                    >
                        Recuperar
                    </button>
                </motion.div>
            )}

            <form onSubmit={handleRegister}>
                <Row>
                    <Col md={6}>
                        <div className="auth-input-group">
                            <input
                                type="text"
                                className="auth-input"
                                placeholder="Nombre"
                                value={formData.Nombre}
                                onChange={e => setFormData({ ...formData, Nombre: e.target.value })}
                                required
                            />
                            <FontAwesomeIcon icon={faUser} className="auth-input-icon" />
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="auth-input-group">
                            <input
                                type="text"
                                className="auth-input"
                                placeholder="Apellido"
                                value={formData.Apellido}
                                onChange={e => setFormData({ ...formData, Apellido: e.target.value })}
                                required
                                style={{ paddingLeft: '1rem' }}
                            />
                        </div>
                    </Col>
                </Row>

                <div className="auth-input-group">
                    <input
                        type="text"
                        className="auth-input"
                        placeholder="CUIT (Sin guiones)"
                        value={formData.Cuit}
                        onChange={e => setFormData({ ...formData, Cuit: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faIdCard} className="auth-input-icon" />
                </div>

                <div className="auth-input-group">
                    <input
                        type="email"
                        className="auth-input"
                        placeholder="Email corporativo"
                        value={formData.Email}
                        onChange={e => setFormData({ ...formData, Email: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faEnvelope} className="auth-input-icon" />
                </div>

                <div className="auth-input-group">
                    <input
                        type="text"
                        className="auth-input"
                        placeholder="Teléfono de contacto"
                        value={formData.Telefono}
                        onChange={e => setFormData({ ...formData, Telefono: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faPhone} className="auth-input-icon" />
                </div>

                <div className="auth-input-group mb-4">
                    <input
                        type="password"
                        className="auth-input"
                        placeholder="Contraseña segura"
                        value={formData.Password}
                        onChange={e => setFormData({ ...formData, Password: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faLock} className="auth-input-icon" />
                </div>

                <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : (
                        <><FontAwesomeIcon icon={faUserPlus} /> Crear Cuenta Administrador</>
                    )}
                </button>

                <div className="text-center">
                    <p className="text-muted small mb-1">¿Ya tienes una cuenta?</p>
                    <button type="button" className="btn btn-link text-primary font-weight-bold p-0 text-decoration-none" onClick={onToggle}>
                        Iniciar Sesión
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Register;
